export default __webpack_public_path__ + "static/media/bat.51541fb8.gif";